import React from "react";

// Usage: <PrimaryButton>Button Text</PrimaryButton>
const PrimaryButton = ({ children, className = "", ...props }) => (
  <button
    className={`inline-flex items-center px-8 py-4 bg-gray-50 border-2 border-blue-700 text-blue-700 font-semibold rounded-2xl transition-all duration-200 shadow-md hover:shadow-xl hover:scale-105 active:scale-95 hover:border-blue-900 focus:border-blue-900 focus:outline-none ${className}`}
    style={{ boxShadow: "0 2px 12px 0 rgba(30, 64, 175, 0.08)" }}
    {...props}
  >
    {children}
  </button>
);

export default PrimaryButton;
